export const REQUEST_STATUS_LABELS = {
  pending: "بانتظار المدير المباشر",
  gm_pending: "بانتظار موافقة المدير العام",
  manager_approved: "بانتظار مدير الإدارة",
  approved: "موافق عليه",
  rejected: "مرفوض",
  manager_rejected: "مرفوض من المدير",
  dm_rejected: "مرفوض من مدير الإدارة",
  cancelled: "ملغى",
};

/** Statuses that still block submitting another request of the same type */
const OPEN_STATUSES = new Set([
  "pending",
  "gm_pending",
  "manager_approved",
  "modified",
]);

export function isOpenRequest(request) {
  return Boolean(request && OPEN_STATUSES.has(request.status));
}

export function isDirectToGmSubmitter(role) {
  return role === "hr" || role === "department-manager";
}

export function isHrSubmittedRequest(request) {
  return request?.submittedByRole === "hr";
}

export function isDirectToGmRequest(request) {
  const workflowType = request?.workflow?.requestType;
  return (
    workflowType === "leave_direct_gm" ||
    workflowType === "permit_direct_gm" ||
    workflowType === "advance_direct_gm" ||
    isDirectToGmSubmitter(request?.submittedByRole)
  );
}

export function isPendingForGm(request) {
  return request?.status === "gm_pending" || isDirectToGmRequest(request);
}

export function getRequestStatusLabel(status) {
  return REQUEST_STATUS_LABELS[status] || status;
}

export function enrichRequestForSubmit(user, request, gmEmployeeId = null) {
  if (isDirectToGmSubmitter(user?.role)) {
    return {
      ...request,
      submittedByRole: user.role,
      currentApproverRole: "gm",
      approverId: gmEmployeeId,
      status: "gm_pending",
    };
  }
  return request;
}

export function getRequestSubmitHint(role, requestType) {
  if (requestType === "advance" || requestType === "سلفة") {
    if (role === "department-manager" || role === "hr") {
      return "يُرسل الطلب إلى المدير العام للموافقة";
    }
    if (role === "hr-staff") {
      return "يُرسل الطلب مباشرة إلى حساب الموارد البشرية للموافقة";
    }
    return "يُرسل الطلب مباشرة إلى الموارد البشرية للموافقة";
  }
  if (isDirectToGmSubmitter(role)) {
    return "يُرسل الطلب إلى المدير العام للموافقة";
  }
  if (role === "hr-staff") {
    return "يُرسل الطلب مباشرة إلى حساب الموارد البشرية للموافقة";
  }
  return "يُرسل الطلب إلى المدير المباشر";
}
